module.exports = __webpack_public_path__ + "img/bob_marley.e727011e.jpg";